import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Icon, IconTypes } from '@eika/icon';

import useText from '@hooks/use-text';
import { range } from '@utils/array';

import './CardControlSkeleton.scss';

const RegionBlockButtonSkeleton = () => {
    const { regionTitle } = useText();

    return (
        <div className="card-control-skeleton">
            <div className="spending-limits-list">
                <h3 className="spending-limits-list__header h3">
                    {regionTitle}
                    <Icon type={IconTypes.INFO_24} />
                </h3>
                <div className="spending-limits-list__element">
                    <Skeleton style={{ width: '100%' }} />
                </div>
            </div>
        </div>
    );
};

const SpendingLimitsSkeleton = () => {
    const { spendingLimitsLabel, regionEcommerce, spendingLimitsNetLabel } = useText();

    return (
        <div className="card-control-skeleton">
            <div className="spending-limits-list">
                <h3 className="spending-limits-list__header h3">
                    {spendingLimitsLabel}
                    <Icon type={IconTypes.INFO_24} />
                </h3>
                {range(2).map((idx) => (
                    <div className="spending-limits-list__element" key={`skeleton-${idx}`}>
                        <Skeleton style={{ width: '100%' }} />
                    </div>
                ))}
            </div>
            <div className="spending-limits-list">
                <h3 className="spending-limits-list__header h3">
                    {regionEcommerce}
                    <Icon type={IconTypes.INFO_24} />
                </h3>
                <div className="spending-limits-list__element">
                    <Skeleton style={{ width: '100%' }} />
                </div>
            </div>
            <div className="spending-limits-list">
                <h3 className="spending-limits-list__header h3">
                    {spendingLimitsNetLabel}
                    <Icon type={IconTypes.INFO_24} />
                </h3>
                <div className="spending-limits-list__element">
                    <Skeleton style={{ width: '100%' }} />
                </div>
            </div>
        </div>
    );
};

const CardControlSkeleton = () => (
    <>
        <SpendingLimitsSkeleton />
        <RegionBlockButtonSkeleton />
    </>
);

export default CardControlSkeleton;
